import { produce } from 'immer';
import { getType } from 'typesafe-actions';

import { Page } from '../common/typings';

import * as actions from './actions';
import { CommonCanvasData } from './typings';

export const getCommonDataInitialState = (): CommonCanvasData => {
    return {
        page: Page.PRESETS,
        isBusy: false
    };
};

export function commonCanvasData(
    state: CommonCanvasData = getCommonDataInitialState(),
    action: actions.CanvasAppAction
): CommonCanvasData {
    return produce(state, draft => {
        switch (action.type) {
            case getType(actions.showBusy):
                draft.isBusy = true;

                return;

            case getType(actions.hideBusy):
                draft.isBusy = false;

                return;

            case getType(actions.changePage):
                draft.page = action.page;

                if (action.ideaId) {
                    draft.ideaId = action.ideaId;
                }

                if (action.page === Page.CONSTRUCTOR && !action.ideaId) {
                    draft.ideaId = undefined;
                }

                return;

            default:
                return;
        }
    });
}
